import { Component,OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {LoginService} from '../../../api/login/login.service';


@Component({
  selector: 'cat-top-bar',
  templateUrl: './top-bar.component.html',
})
export class TopBarComponent implements OnInit{
  logOut = [];

  constructor(
      public authService: LoginService,
      private router: Router
  ){
    
  }

  ngOnInit(){

  }

  onLogOut(){
    // if (localStorage.getItem('id_token')) {
    //   // logged in so return true
    //   this.authService.authToken = null;
    //   localStorage.removeItem('id_token');
    // }

  }


  
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/components/top-bar/top-bar.component.ts